import { render, staticRenderFns } from "./mostrarSugerenciaCompra.vue?vue&type=template&id=4c826b71&scoped=true&"
import script from "./mostrarSugerenciaCompra.vue?vue&type=script&lang=js&"
export * from "./mostrarSugerenciaCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c826b71",
  null
  
)

export default component.exports